<template>
  <div class="cadfm-container-horizontal">

            <ProjectTable v-show="$route.params.view == 'ProjectTable'" 
             :lang="lang.ProjectManager.ProjectTable"></ProjectTable>
            <ProjectNew v-if="$route.params.view == 'ProjectNew'" 
            :lang="lang.ProjectManager.ProjectNew"></ProjectNew>
            <ProjectDetails v-if="$route.params.view == 'ProjectDetails'" 
            :lang="lang.ProjectManager.ProjectDetails"></ProjectDetails>
            <ProjectDerive v-if="$route.params.view == 'ProjectDerive'" 
            :lang="lang.ProjectManager.ProjectDerive"></ProjectDerive>
            <Categories v-if="$route.params.view == 'Categories'"
             :lang="lang.ProjectManager.Categories"></Categories>
            <Properties v-if="$route.params.view == 'Properties'"
             :lang="lang.ProjectManager.Properties"></Properties>
            <ProjectImportBom v-if="$route.params.view == 'ProjectImportBom'"
             :lang="lang.ProjectManager.ProjectImportBom"></ProjectImportBom>
            <ProjectImportBomLst v-if="$route.params.view == 'ProjectImportBomLst'" 
            :lang="lang.ProjectManager.ProjectImportBomLst">
            </ProjectImportBomLst>
            <ProjectBom v-if="$route.params.view == 'ProjectBom'"
             :lang="lang.ProjectManager.ProjectBom"></ProjectBom>
            <ProjectImportIPC v-if="$route.params.view == 'ProjectImportIPC'" 
            :lang="lang.ProjectManager.ProjectImportIPC">
            </ProjectImportIPC>
 </div>
</template>

<script>
import ProjectTable from "@/components/ProjectManager/Views/ProjectTable";
import ProjectNew from "@/components/ProjectManager/Views/ProjectNew";
import ProjectDetails from "@/components/ProjectManager/Views/ProjectDetails";
import ProjectDerive from "@/components/ProjectManager/Views/ProjectDerive";
import Categories from "@/components/ProjectManager/Views/Categories";
import Properties from "@/components/ProjectManager/Views/Properties";
import ProjectImportBom from '@/components/ProjectManager/Views/ProjectImportBom'
import ProjectImportBomLst from '@/components/ProjectManager/Views/ProjectImportBomLst'
import ProjectBom from '@/components/ProjectManager/Views/ProjectBom'
import ProjectImportIPC from '@/components/ProjectManager/Views/ProjectImportIPC'

//import Left from '@/components/PartManager/Left/Left'
//import Right from '@/components/PartManager/Right/Right'
//import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  name: "ProjectManager",
  components: {
    ProjectTable,
    ProjectNew,
    ProjectDetails,
    ProjectDerive,
    Categories,
    Properties,
    ProjectImportBom,
    ProjectImportBomLst,
    ProjectBom,
    ProjectImportIPC
  },
  props: {
    lang: Object
  },
  data() {
    return {
      sectionPrefix: "projm",
      basicView: "ProjectTable", 
    };
  },
  computed: {
    
    
  },
  beforeCreate() {
    this.$store.dispatch("setView", "ProjectTable");
  },
  created() {
    this.$store.dispatch("showLoader", { visible: false, text: "" });
    this.$store.dispatch("setSectionPrefix", this.sectionPrefix);
  },
  methods: {
    
  }
};
</script>


<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ProjectManager/ProjectManager.vue